import { inject } from "mobx-react";
import { Hotel } from "typings/microserviceModels/hotels-flex-module";
import { ExtendedContextStore } from "typings/flexFramework/FlexDefinitions";
import { UitkFigure, UitkFigureAspectRatioType } from "uitk-react-images";
import { HotelHeartButton } from "../HotelHeartButton/HotelHeartButton";
import * as React from "react";
import { LazyLoadedImage } from "components/utility/LazyLoadedImage/LazyLoadedImage";
import { AnalyticsStore } from "bernie-core";
import { HotelBadge } from "./HotelBadge/HotelBadge";
import { getOptimizedImageUrl } from "src/components/flexComponents/Hotels/utils/hotelOptimizedImage";

interface CardMediaOverallInfoProps {
  index: number;
  hotel: Hotel;
  analytics?: AnalyticsStore;
  context: ExtendedContextStore;
  moduleName?: string;
  displayBadges?: boolean;
  showHeartButton?: boolean;
}

/**
 * Represents a {@see HotelCard}'s media (image, carousel, favorite button, etc.)
 */

export const CardMediaOverallInfo: React.FC<CardMediaOverallInfoProps> = inject("analytics")(
  ({ hotel, context, moduleName = "hotels", displayBadges, showHeartButton = true, ...props }) => {
    const { hotelName } = hotel;

    const hotelImageUrl = getOptimizedImageUrl(hotel, context);

    return (
      <UitkFigure ratio={UitkFigureAspectRatioType.R21_9} {...props}>
        <div>
          <LazyLoadedImage src={hotelImageUrl} alt={hotelName} context={context} />
        </div>
        {showHeartButton && <HotelHeartButton moduleName={moduleName} hotel={hotel} />}
        {displayBadges && <HotelBadge travelerReviewContent={hotel.travelerReviewContent} />}
      </UitkFigure>
    );
  }
);
